import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility, CustomScrollbarProps} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEPresentationItem from './oe-presentation-item';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../lib/react/update-retarder';

export default class OEPresentationList extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.presentations = [];

        this.state = {
            uiEnabled: false,
            presentations: [],
            activePresID: -2
        };

        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        this.onActivePresentationChanged = this.onActivePresentationChanged.bind(this);
        this.onPresentationAdded = this.onPresentationAdded.bind(this);
        this.onPresentationRemoved = this.onPresentationRemoved.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);

        this.onItemClicked = this.onItemClicked.bind(this);
    }

    setStateUpdate(spec)   {
        OEToolbox.updateComponentState(this, spec);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAdded, this.onPresentationAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationRemoved, this.onPresentationRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAdded, this.onPresentationAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationRemoved, this.onPresentationRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
    }

    updateUIState()   {
        this.setState({
            uiEnabled: this.oe.sharedInterface.getUIControllerPresentation().getUIEnabled()
        });
    }

    updatePresentations()   {
        let controller = this.oe.sharedInterface.getUIControllerPresentation();
        let presentations = controller.getPresentationDataList();

        this.presentations = presentations.map((pres) => {
            return {id: pres.id, viewFlags: pres.viewFlags};
        });

        this.setState({presentations: Array.from(this.presentations)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.presentations = [];
            this.setState({uiEnabled: false, presentations: [], activePresID: -2});
            return;
        }

        retardUpdate(this, () => {
            this.updatePresentations();
            this.onActivePresentationChanged();
            this.updateUIState();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.presentation) {
            this.updateUIState();
        }
    }

    onActivePresentationChanged(message, userInfo)   {
        let activePresID = typeof(userInfo) === 'undefined' ? this.oe.sharedInterface.getUIControllerPresentation().getActivePresentationID() : userInfo.presID;
        this.setState({activePresID: activePresID});
    }

    onPresentationAdded(message, userInfo)   {
        let presIndex = userInfo.presentation;
        let pres = userInfo.presData;
        this.presentations.splice(presIndex, 0, {id: pres.id, viewFlags: pres.viewFlags});
        this.setState({presentations: Array.from(this.presentations)});
    }

    onPresentationRemoved(message, userInfo)   {
        let presIndex = userInfo.presentation;
        this.presentations.splice(presIndex, 1);
        this.setState({presentations: Array.from(this.presentations)});
    }

    onPresentationDataChanged(message, userInfo) {
        if(!(userInfo.changeFlags & this.oe.Module.PresentationDataChangeFlags.view.value)) return;
        let presIndex = userInfo.presentation;
        let pres = userInfo.presData;
        this.presentations[presIndex] = {id: pres.id, viewFlags: pres.viewFlags};
        this.setState({presentations: Array.from(this.presentations)});
    }

    render() {
        let disabled = !this.state.uiEnabled;

        //
        const {className: scrollbarClassName, style: scrollbarSyle, ...rest} = this.props.scrollbar;

        let className = this.props.className + ' presentations-view';
        if(scrollbarClassName)    className = className + ' ' + scrollbarClassName;

        let style = this.props.style;
        if(scrollbarSyle)    {
            style = style ? Object.assign({}, style, scrollbarSyle) : scrollbarSyle;
        }

        //
        let presentations = this.state.presentations;

        if(typeof(this.props.viewFlagsFilter) === 'number') {
            presentations = presentations.filter(pres => (this.props.viewFlagsFilter & pres.viewFlags));
        }

        presentations = presentations.map((pres, index) =>
            <OEPresentationItem
                key={pres.id}
                className={this.props.itemClassName}
                moduleId={this.props.moduleId}
                disabled={disabled}
                selected={pres.id === this.state.activePresID}
                id={pres.id}
                presID={pres.id}
                index={index}
                showIndex={this.props.showIndices}
                onClick={this.onItemClicked}
            />
        );

        //
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <CustomScrollbar 
                    className={className}
                    style={style}
                    {...rest}
                >
                    <ul>{presentations}</ul>
                </CustomScrollbar>
            </React.Fragment>
        );
    }

    onItemClicked(id)   {
        this.oe.sharedInterface.getUIControllerPresentation().setActivePresentationID(id);
    }
}

OEPresentationList.defaultProps = {
    className:                          '',
    itemClassName:                      '',
    moduleId:                           '',
    showIndices:                        false,
    scrollbar: {
        horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.always,
        verticalTrackVisiblity:         CustomScrollbarTrackVisibility.none,
    }
};

OEPresentationList.propTypes = {
    className:                          PropTypes.string,
    style:                              PropTypes.object,
    itemClassName:                      PropTypes.string,
    moduleId:                           PropTypes.string,
    showIndices:                        PropTypes.bool,
    viewFlagsFilter:                    PropTypes.number,
    scrollbar:                          CustomScrollbarProps.propsDecl
};